import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Show } from "@clerk/react";
import { errMsg, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/layout/Logo";

const ST = { used: "Questo invito è già stato usato.", revoked: "Questo invito è stato revocato.", expired: "Questo invito è scaduto." };

function Accept({ token }) {
  const api = useApi();
  const [info, setInfo] = useState(null);
  const [done, setDone] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/invites/${token}`).then(({ data }) => setInfo(data)).catch((e) => setErr(errMsg(e))); }, [api, token]);
  const accept = async () => { try { const { data } = await api.post(`/invites/${token}/accept`); setDone(data); } catch (e) { setErr(errMsg(e)); } };
  if (err) return <p className="text-sm text-red-600" data-testid="invite-error">{err}</p>;
  if (!info) return <p className="text-sm text-slate-500">Caricamento…</p>;
  if (done) return (
    <div className="space-y-2" data-testid="invite-accepted"><p className="text-sm text-emerald-700">Fatto: ora sei membro di «{info.tenant_name}» con il ruolo {info.role_label}.</p>
      <p className="text-xs text-slate-500">Puoi chiudere questa pagina oppure aprire subito la tua area di lavoro.</p>
      <Button asChild className="bg-sky-600 hover:bg-sky-700"><a href={`/area/${done.tenant_id}`} data-testid="invite-open-area">Apri la tua area</a></Button></div>);
  return (
    <div className="space-y-4">
      <p className="text-sm text-slate-700">Sei stato invitato in <b>{info.tenant_name}</b> con il ruolo <b>{info.role_label}</b>.</p>
      {info.state !== "pending" ? <p className="text-sm text-amber-700" data-testid="invite-invalid">{ST[info.state]}</p> :
        <Button onClick={accept} className="bg-sky-600 hover:bg-sky-700" data-testid="invite-accept">Accetta l'invito</Button>}
    </div>
  );
}

export default function InvitePage() {
  const { token } = useParams();
  const back = encodeURIComponent(window.location.href);
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6" data-testid="invite-page">
      <div className="w-full max-w-md space-y-6 rounded-xl border border-slate-200 bg-white p-8">
        <Logo />
        <Show when="signed-in"><Accept token={token} /></Show>
        <Show when="signed-out"><p className="text-sm text-slate-700">Per accettare l'invito entra con il tuo account. Se non ne hai ancora uno, crealo con la stessa email: alla fine torni qui e accetti l'invito.</p>
          <div className="flex flex-wrap gap-2">
            <Button asChild className="bg-sky-600 hover:bg-sky-700"><a href={`/sign-up?redirect_url=${back}`} data-testid="invite-signup">Sono nuovo: crea un account</a></Button>
            <Button asChild variant="outline"><a href={`/sign-in?redirect_url=${back}`} data-testid="invite-signin">Ho già un account: accedi</a></Button></div></Show>
      </div>
    </div>
  );
}
